function firstItem(collection) {
  return collection?.at?.(0) ?? collection?.[0];
}

function read(record, key) {
  return record.get?.(key) ?? record[key];
}

export function isRelatedClientValid(relatedClient) {
  if (!relatedClient) {
    return false;
  }

  relatedClient.validate?.();
  relatedClient.set?.('_isDirty', true);

  const relatedEmail = firstItem(relatedClient.emails);
  const relatedPhone = firstItem(relatedClient.phones);

  relatedEmail?.validate?.();
  relatedPhone?.validate?.();

  const firstName = read(relatedClient, 'firstName');
  const lastName = read(relatedClient, 'lastName');

  return (
    Boolean(firstName?.trim()) &&
    Boolean(lastName?.trim()) &&
    Boolean(relatedClient.validations?.isValid) &&
    (relatedEmail?.validations?.isValid ?? true) &&
    (relatedPhone?.validations?.isValid ?? true)
  );
}
